<script setup lang="ts">
import AuthorizationsForNoAuthorization from "@/components/common/authorization/AuthorizationsForNoAuthorization.vue";
import AuthorizationForScope from "@/components/common/authorization/AuthorizationForScope.vue";
import { getListColumnName } from "@/composable/authorization/grantableInfos";

interface Props {
  user: string;
  date: string;
  comment: string;
  application: any;
  applicationName: string;
  authorizationId: string;
  authorizations: any;
  currentAuthorization: any;
  datatypes: any;
  hasDependencies: any;
  initialized: boolean;
  referencesScopes: any;
}

const props = defineProps<Props>();
const listColumnName = getListColumnName();
const emit = defineEmits(["update:authorization"]);
</script>

<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <p><b>{{ $t("requestAuthorization.request-user-name") }} :</b> {{ props.user }}</p>
      <p><b>{{ $t("requestAuthorization.request-date-create") }} :</b> {{ props.date }}</p>
      <p><b>{{ $t("requestAuthorization.request-comment") }} :</b> {{ props.comment }}</p>
      <p><b>{{ $t("requestAuthorization.right-request") }} :</b> </p>
    </div>

    <div class="column is-12">
      <AuthorizationsForNoAuthorization
        v-if="
          props.initialized &&
            props.datatypes.withoutScope &&
            Object.keys(props.datatypes.withoutScope).length !== 0
        "
        class="tableDetails"
        :application="props.application"
        :authorization="props.authorizations"
        :data-types="props.datatypes.withoutScope"
        :has-dependencies="props.hasDependencies"
        :list-column-scope="listColumnName['withoutScope']"
        :is-disable="true"
        @update:authorization="$emit('update:authorization', $event)"
      />
      <AuthorizationForScope
        v-if="
          props.initialized &&
            props.datatypes.withScope &&
            Object.keys(props.datatypes.withScope).length !== 0
        "
        :application="props.application"
        :authorization="props.authorizations"
        :authorizations-description="props.authorizations"
        :data-types="props.datatypes.withScope"
        :has-dependencies="props.hasDependencies"
        :list-column-scope="listColumnName['withScope']"
        :references-scopes="props.referencesScopes"
        :is-disable="true"
        @update:authorization="$emit('update:authorization', $event)"
      />
    </div>
  </div>
</template>

<style>

</style>
